'use strict';
angular.module('weixinLeftModule', [])
    .controller('weixinLeftCtrl', ['$scope', '$q', 'trsHttpService', '$state', '$element', '$timeout', 'noticeWindowService', 'editingMediatype', 'messagePublishService', function($scope, $q, trsHttpService, $state, $element, $timeout, noticeWindowService, editingMediatype, messagePublishService) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                channelTypeMap: {
                    '认证服务号': 'icon-creative_distributio18',
                    '认证订阅号': 'icon-creative_distributio17',
                    '服务号': 'icon-creative_distributio16',
                    '订阅号': 'icon-creative_distributio15',
                },
                channelTypeIconMap: {
                    '认证服务号': 'icon-creative_distributio22',
                    '认证订阅号': 'icon-creative_distributio21',
                    '服务号': 'icon-creative_distributio19',
                    '订阅号': 'icon-creative_distributio20',
                },
                selectedChannelId: '',

            };
            $scope.data = {
                AccountFirstFlag: {}, // 用于校验第一次进入
                selected: {},
                channels: [],
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            getWeixinSites();
        }

        /**
         * [switchChannel description]切换栏目
         *
         * @param   {[type]}  platform  [platform description]
         * @param   {[type]}  channel   [channel description]被点击的栏目
         *
         * @return  {[type]}            [return description]
         */
        $scope.switchChannel = function(platform, channel) {
            $scope.data.selected = channel;
            $scope.status.selectRecycle = false;
            var routerName = 'front.editctr.weixin.' + platform;
            $state.go(routerName, { wxchannelid: channel.CHANNELID, siteid: channel.SITEID }, { reload: routerName });
            $scope.status.selectedChannelId = channel.CHANNELID;
            getWeixinAccessAuthority();
            // 第一次进来的标志 调用有效期验证的弹窗提醒
            if (!$scope.data.AccountFirstFlag[channel.CHANNELID]) {
                $scope.loadingPromise = noticeWindowService.getAccountValidityInfo(editingMediatype.weixin, channel);
                $scope.data.AccountFirstFlag[channel.CHANNELID] = true;
            }
        };

        /**
         * [getWeixinSites description] 获取微信的站点列表,接口名称写的是查站点
         * @return {[type]} [description]
         */
        function getWeixinSites() {
            var deffer = $q.defer();
            if ($scope.data.channels && $scope.data.channels.length !== 0) {
                deffer.resolve();
                return deffer.promise;
            }
            var params = {
                MediaType: 4,
                PAGESIZE: 1000,
                methodname: 'queryWebSitesByMediaType',
                serviceid: 'mlf_mediasite',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.channels = data.DATA;
                $scope.data.selected = data.DATA[0];
                $scope.status.selectedChannelId = $state.params.wxchannelid ? $state.params.wxchannelid : data.DATA[0].CHANNELID;
                angular.forEach(data.DATA, function(obj, index) {
                    getChannelType(obj.CHANNELID).then(function(data) {
                        $scope.data.channels[index].CHANNELTYPE = data;
                    });
                });
                wxQunFaUnReadMsg();
                errorMsg();
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [getChannelType description]查询公众号类型
         *
         * @param   {[type]}  CHANNELID  [CHANNELID description]
         *
         * @return  {[type]}             [return description]
         */
        function getChannelType(CHANNELID) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'getChannelType',
                ChannelIds: CHANNELID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                deffer.resolve(data[CHANNELID]);
            });
            return deffer.promise;
        }

        /**
         * [getWeixinAccessAuthority description] 获取微信权限
         * @return {[type]} [description]
         */
        function getWeixinAccessAuthority() {
            if (!$scope.data.channels || $scope.data.channels.length === 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryCanOperOfWeChat',
                WeChatId: $scope.status.selectedChannelId === undefined ? $scope.data.channels[0].CHANNELID : $scope.status.selectedChannelId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(rights) {
                $scope.status.weixinAccessAuthority = rights;
            });
        }

        /**
         * [autoLocation description]自动定位
         *
         * @param   {[type]}  platform  [platform description]
         *
         * @return  {[type]}            [return description]
         */
        $scope.autoLocation = function(platform) {
            getWeixinSites().then(function() {
                $timeout(function() {
                    var routerArray = $state.current.name.split('.');
                    if (routerArray.length === 3 || routerArray.length === 4) {
                        if ($scope.status.selectedChannelId !== undefined) {
                            // $state.go('front.editctr.weixin.' + platform, { 'wxchannelid': $scope.status.selectedChannelId });
                            $scope.switchChannel(platform, $scope.data.selected);
                        } else {
                            $element.find('a')[0].click();
                        }
                    } else {
                        $scope.status.selectedChannelId = $state.params.wxchannelid;
                    }
                });
            });
        };

        /**
         * [toRecycle description] 到废稿箱
         * @param  {[type]} platform [description] 平台
         * @return {[type]}          [description]
         */
        $scope.toRecycle = function(platform) {
            var routerName = 'front.editctr.weixin.' + platform + '.recycle';
            $state.go(routerName, { wxchannelid: $state.params.wxchannelid }, { reload: routerName });
            $scope.status.selectRecycle = true;
        };

        /**
         * [newMediaCloudService description] 到新新疆维吾尔自治区媒体云平台服务平台
         * @return {[type]} [description]
         */
        $scope.newMediaCloudService = function() {
            window.open('https://op.tmuyun.com');
        };

        /**
         * [errorMsg description] 失败消息数量
         * @return {[type]} [description]
         */
        function errorMsg() {
            messagePublishService.subscribe('wxLeftFaCont', function(event, data) {
                $scope.data.channels.map((item) => {
                    item.errorMsg = data[item.CHANNELID];
                    item.errorMsg = item.errorMsg > 99 ? '99+' : item.errorMsg;
                });
            }, $scope);
        }

        /**
         * [wxQunFaUnReadMsg description] 微信群发失败未读消息
         *
         * @return  {[type]}  [return description]
         */
        function wxQunFaUnReadMsg() {
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'getSendCardFailedCount',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.channels.map((item) => {
                    item.errorMsg = data[item.CHANNELID];
                    item.errorMsg = item.errorMsg > 99 ? '99+' : item.errorMsg;
                });
            });
        }
    }]);
